var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgExpandIcon = function (props) { return (_jsx("svg", __assign({ width: 19, height: 24, viewBox: "0 0 19 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "m8.295 7.41 4.58 4.59-4.58 4.59L9.705 18l6-6-6-6-1.41 1.41Z", fill: "#9E9E9E" }) }))); };
var Memo = memo(SvgExpandIcon);
export default Memo;
//# sourceMappingURL=ExpandIcon.js.map